<template>
  <div>
    <ca-row>
      <ca-col>
        <ca-button @click="onEdit(intern.id)">
          Editar
        </ca-button>
        <ca-button class="ca-u-min-margin-left" @click="onDelete()">
          Excluir
        </ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-page>
          <ca-async-content-wrapper
            :on-fetch="getIntern"
            :on-fetch-success="setIntern">
            <div v-if="intern">
              <ca-row>
                <ca-col>
                  <ca-heading :text="intern.internName"></ca-heading>
                  <p>
                    <span class="ca-u-color-grey">
                      CPF:
                    </span>
                    <span>
                      {{ intern.cpf | caCpf }}
                    </span>
                  </p>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Estagiário possui matrícula vinculada ao eSocial?">
                    {{ intern.registrationOption.description }}
                  </ca-field>
                </ca-col>
                <ca-col size="4">
                  <ca-field label="Matrícula do eSocial">
                    {{ intern.registration }}
                  </ca-field>
                </ca-col>
              </ca-row>

              <ca-row>
                <ca-col size="4">
                  <ca-field label="Sexo">
                    {{ intern.gender.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Raça/Cor">
                    {{ intern.raceColor.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Grau de Instrução">
                    {{ intern.educationLevel.description }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Data de Nascimento">
                    {{ intern.birthDate | caDate }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Categoria">
                    {{ intern.internCategory.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Data do Início Estágio">
                    {{ intern.beginDate | caDate }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Data do Fim Estágio">
                    {{ intern.endDate | caDate }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Valor da Bolsa">
                    R$ {{ intern.scholarship | caCurrency }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Carga semanal em horas">
                    {{ intern.weeklyHours }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Estágio Obrigatório">
                    {{ intern.required ? 'Sim' : 'Não' }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Nível do Estágio">
                    {{ intern.internLevel.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Área de Atuação">
                    {{ intern.occupationArea }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="CNPJ da Instituição de Ensino">
                    {{ intern.institutionRegistration }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Nome da Instituição de Ensino">
                    {{ intern.institutionName }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Endereço">
                    {{
                      `${intern.street}, ${intern.residenceNumber} - ${intern.neighborhood}`
                    }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Cidade">
                    {{ intern.city }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Estado">
                    {{ intern.state.value }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Telefone">
                    {{ intern.phone }}
                  </ca-field>
                </ca-col>
              </ca-row>
              <ca-row>
                <ca-col size="4">
                  <ca-field label="Email">
                    {{ intern.email }}
                  </ca-field>
                </ca-col>

                <ca-col size="4">
                  <ca-field label="Situação no eSocial">
                    {{ intern.esocialStatus.description }}
                  </ca-field>
                </ca-col>

                <ca-col size="4"> </ca-col>
              </ca-row>
            </div>
          </ca-async-content-wrapper>
        </ca-page>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { getIntern, deleteIntern } from './internService';

export default {
  name: 'InternsViewPage',
  data() {
    return {
      intern: null,
      internId: this.$route.params.id,
    };
  },
  methods: {
    getIntern() {
      return getIntern(this.$route.params.id);
    },
    setIntern(intern) {
      this.intern = intern;
    },
    onEdit(id) {
      this.$router.push({ name: 'EditIntern', params: { id } });
    },
    onDelete() {
      this.$caConfirm({
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente excluir esse estagiário?',
        onConfirm: () => {
          deleteIntern(this.internId)
            .then(() => {
              this.$router.back();
              this.$toaster.success('Estagiário excluído com sucesso.');
            })
            .catch(() => {
              this.$toaster.error('Erro ao excluir o estagiário');
            });
        },
      });
    },
  },
};
</script>
